import axios from 'axios';
import qs from 'qs';

export default class HotelService {

	constructor(client){
		this.url = '/clients-webservice/hotels';
		this.auth = {
				username: client.login,
				password: client.key
		}
	};

	list(filter) {
		return axios.get(`${this.url}/prices`, {auth: this.auth, params: filter, paramsSerializer: params => { return qs.stringify(params) }});
	}

	getHotelInfo(hotelId, lang) {
		return axios.get(`${this.url}/${hotelId}?languageCode=${lang}`, {auth: this.auth});
	}
}



// WEBPACK FOOTER //
// ./src/services/HotelService.js